// extracted by mini-css-extract-plugin
export default {"wrapper":"src-modules-core-components-BannerNotice-style__wrapper_GW3zu"};